import { createMemoSelector } from '../helpers/selector'
import { FEED_PAGE_SIZE } from '../../helpers/const'

export const selectIsFeedMode = state => state.feed.isFeedMode
export const selectFeedPage = state => state.feed.page
export const selectFeedTotalCount = state => state.feed.totalCount
export const selectFeedIsLoading = state => state.feed.isLoading
export const selectFeedQuery = state => state.feed.query
export const selectFeedItems = state => state.feed.items

export const selectFeedTotalPages = state => (
  state.feed.totalCount ? Math.ceil(state.feed.totalCount / FEED_PAGE_SIZE) : 0
)

export const selectFeedHasNext = state => selectFeedPage(state) < selectFeedTotalPages(state)
export const selectFeedHasPrev = state => selectFeedPage(state) > 1

/*
  Maps feed items (ordered product ids of the current page) to the same product
  shape emitted by groupProductsByCategory, so grid items and carousel consumers
  work unchanged.
*/
export const selectFeedProducts = createMemoSelector(
  selectFeedItems,
  state => state.products,
  (items, products) => items
    .map(id => products[id])
    .filter(Boolean)
    .map((product, index) => ({
      collectionIndex: index,
      title: product.title,
      id: product.id,
      mediaType: product.mediaType,
    })),
)
